export default {"src":"/_next/static/media/mba.060163fb.svg","height":78,"width":132};